// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3TtzR","label":"LabeledBox_label__2qqf3"};